import React, { useState } from 'react'
import { supabase } from '../../supabaseClient'
import { useSelector } from 'react-redux'
import NotificationBox from '../NotificationBox/NotificationBox.js'

const NotificationButton = ({ notifications, setNotifications }) => {
  const [showNotification, setShowNotification] = useState(false)
  const currentUser = useSelector(state => state.user.userInfo)

  const toggleNotificationBox = async () => {
    const nextState = !showNotification
    setShowNotification(nextState)

    // If closing the notification box or clearing them out
    if (nextState === false && notifications.length > 0) {
      try {
        // Example: If notifications are stored in a 'notifications' table linked by user_id
        if (currentUser?.id) {
          await supabase
            .from('notifications')
            .update({ read: true })
            .eq('user_id', currentUser.id)
        }

        // Clear local state
        setNotifications([])
      } catch (err) {
        console.error('Error clearing notifications:', err.message)
      }
    }
  }

  return (
    <button className="relative focus:outline-none">
      <i className="fa-regular fa-bell text-lg cursor-pointer" onClick={toggleNotificationBox}> 
        {
          showNotification ? <NotificationBox notifications={notifications} /> : null
        }
        {
          notifications && notifications.length > 0 ?
          <div className="text-xs font-sans absolute top-0 right-0 w-4 h-4 rounded-sm bg-red-500 text-white flex items-center justify-center translate-x-1/2 translate-y-0">
             {notifications.length}
          </div>
          : null
        }
      </i>
    </button>
  )
}

export default NotificationButton
